import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StandardLayoutComponent } from './layout/standard-layout/standard-layout.component';
import { HomeComponent } from './layout/home/home.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { PermissionGuard } from './shared/guards/permission.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'calendar',
    pathMatch: 'full'
  },
  {
    path: '',
    component: StandardLayoutComponent,
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('./login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule)
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./calendar/calendar.module').then(m => m.CalendarModule),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./user/user.module').then(m => m.UserModule),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'tenants',
        loadChildren: () =>
          import('./tenant/tenant.module').then(m => m.TenantModule),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'org-units',
        loadChildren: () =>
          import('./org-unit/org-unit.module').then(m => m.OrgUnitModule),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'medical-history',
        loadChildren: () =>
          import('./medical-history/medical-history.module').then(
            m => m.MedicalHistoryModule
          ),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./reporting/reporting.module').then(
            m => m.ReportingModule
          ),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./customer/customer.module').then(
            m => m.CustomerModule
          ),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./settings/settings.module').then(
            m => m.SettingsModule
          ),
        canMatch: [AuthGuard.canMatchFn],
        canActivate: [PermissionGuard.canActivateFn]
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard.canActivateFn]
      },
      {
        path: 'home/:actionName',
        component: HomeComponent,
        canActivate: [AuthGuard.canActivateFn]
      }
    ]
  },
  {
    path: 'add-customer',
    loadChildren: () =>
      import('./add-customer/add-customer.module').then(
        m => m.AddCustomerModule
      ),
    canMatch: [AuthGuard.canMatchFn],
    canActivate: [PermissionGuard.canActivateFn]
  },
  { path: '**', redirectTo: 'calendar' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
